import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { getOrderCssClass } from '../../shared/Site';

interface CustomerInvoicablesListRowProps {
    brokerFirmName: string;
    orderCount: number;
    invoiceBillingMethod: string;
    key: number;
    showInvoice: () => void;
    site: number;
    checked: boolean;
    onCheckboxChange: () => void;
}

const CustomerInvoicablesListRow = (props: CustomerInvoicablesListRowProps) => {
    return (
        <tr onClick={props.showInvoice} className={getOrderCssClass(props.site)}>
            <td>
                <input
                    type="checkbox"
                    checked={props.checked}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        e.stopPropagation();
                        props.onCheckboxChange();
                    }}
                />
            </td>
            <td>{props.brokerFirmName}</td>
            <td>{props.orderCount}</td>
            <td>{Translate(props.invoiceBillingMethod)}</td>
            <td></td>
        </tr>
    );
};

export default CustomerInvoicablesListRow;
